// extracted by mini-css-extract-plugin
export default {"footer_container":"styles_footer_container__qnTgY","footer_content":"styles_footer_content__z8lD+"};